module.exports = __webpack_public_path__ + "static/media/image_57.13b1a2a4.png";